import  ReactGA  from "react-ga4";
import { global_var } from "../services/login-config";


function trackEvent(eventName, params) {
    if (global_var.companyId) {
      params.company_id = global_var.companyId;
    }
    if (global_var.company_name) {
      params.company_name = global_var.company_name;
    }
    params.domain_name = global_var.domain_name;
    ReactGA.event(eventName, params);
  }

export {trackEvent};